import { BigNumber } from 'bignumber.js'

export const convertUSD = (balance, price) => {
  const bignumBalance = new BigNumber(balance)
  const bignumPrice = new BigNumber(price)

  return bignumBalance.multipliedBy(bignumPrice).decimalPlaces(2, BigNumber.ROUND_DOWN).toString()
}
